module.exports = __webpack_public_path__ + "img/espantada.2f0ded7d.png";